import { GetAllJoints } from "@project-rouge/rg-core";
import { Vector3 } from "three";
var _center = new Vector3();
var _vector3 = new Vector3();
function getBuildingCenter(building, bone) {
	const joints = bone ? bone.joints : GetAllJoints(building.data.anatomy);
	_center.setScalar(0);
	for (const joint of joints) _center.add(_vector3.fromArray(joint.pos));
	_center.divideScalar(joints.length);
	let top = 0;
	if (bone) top = building.data.levels.find((lvl) => lvl.levelIndex === bone.floors).floorWorldBottom;
	else top = Math.max(...building.data.levels.map((lvl) => lvl.floorWorldBottom));
	_center.y = top * .5;
	return _center.toArray();
}
export { getBuildingCenter };

//# sourceMappingURL=index210.js.map